import { Country } from '@dreryk/address-common-api';

import { commonTranslationKeys, TranslatableText, WithFieldController } from '@dreryk/react-common';
import { Select, StyledMaxWidth } from '@dreryk/react-components';

import { CountriesSelectList } from './countriesSelectList/CountriesSelectList';
import { getCountryDisplayValue } from './countriesSelectList/CountriesSelectList.utils';
import { translationKeys } from './translations';

type PassportCountryFieldProps = WithFieldController<unknown> & {
   readonly label?: TranslatableText;
};

export const PassportCountryField = (props: PassportCountryFieldProps): JSX.Element => {
   return (
      <StyledMaxWidth maxWidth={308}>
         <Select<Country>
            testId={'passportCountry'}
            triggerLabelExtractor={getCountryDisplayValue}
            controller={props.controller}
            defaultValue={null}
            label={props.label || translationKeys.passportCountry.label}
            placeholder={commonTranslationKeys.choose}
            maxHeight={190}
            searchInputEnabled
         >
            <CountriesSelectList />
         </Select>
      </StyledMaxWidth>
   );
};
